import React, { Component } from 'react';
import ReactStars from 'react-stars';
import { TextInput, Select, Checkbox } from '../../inputs';
import './MatchSquadPlayer.css';

class MatchSquadPlayer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			goals: {
				0: {
					name: 0,
					id: 0,
				},
				1: {
					name: 1,
					id: 1,
				},
				2: {
					name: 2,
					id: 2,
				},
				3: {
					name: 3,
					id: 3,
				},
				4: {
					name: 4,
					id: 4,
				},
				5: {
					name: 5,
					id: 5,
				},
			},
			goalsById: [0, 1, 2, 3, 4, 5],
			cards: {
				0: {
					name: 'None',
					id: 0,
				},
				1: {
					name: 'Yellow',
					id: 1,
				},
				2: {
					id: 2,
					name: '2 Yellow',
				},
				3: {
					id: 3,
					name: 'Red',
				},
			},
			cardsById: [0, 1, 2, 3],
		};
	}
	componentDidMount() {}
	componentWillUnmount() {}
	onGoalsChange = val => {
		if (typeof val === 'undefined' || val === '') {
			val = '0';
		}
		this.props.onGoalChange(val, this.props.playerReport);
	};
	onCardsChange = val => {
		if (typeof val === 'undefined' || val === '') {
			val = '0';
		}
		this.props.onCardChange(parseInt(val, 10), this.props.playerReport);
	};
	onTextChange = e => {
		this.props.onTextChange(e.target.value, this.props.playerReport);
	};
	onPositionChange = val => {
		this.props.onPositionChange(this.props.positions[val], this.props.playerReport);
	};
	onRatingChange = val => {
		this.props.onRatingChange(val, this.props.playerReport);
	};
	_getPositionId() {
		let v = null;
		this.props.positions.map((val, i) => {
			if (this.props.playerReport.onChange.position === val) {
				v = i;
				return i;
			}
		});
		return v;
	}
	render() {
		return (
			<div className="flexContainerRow matchSquadPlayer">
				<div className="item">
					<div className="flexContainerRow">
						<div className="item">
							<img
								title={this.props.player.firstName + ' ' + this.props.player.surname}
								alt={this.props.player.surname}
								src={this.props.player.playerAvatar}
							/>
						</div>
						<div className="item grey5">
							<div className="flexContainerCol">
								<div className="player-name">
									<span className="firname">{this.props.player.firstName} </span>
									<span className="surname">{this.props.player.surname}</span>
								</div>
								<div className="squad-number">#{this.props.player.squadNumber} </div>
								<div className="item">
									{!this.props.playerReport.readOnly ? (
										<Select
											prompt="Position"
											currentVal={this._getPositionId()}
											options={this.props.positions.reduce((acc, elem, ind) => {
												acc[ind] = {
													id: ind,
													name: elem.toUpperCase(),
												};
												return acc;
											}, {})}
											optionsById={Array.from({ length: this.props.positions.length }, (v, i) => i)}
											onChange={this.onPositionChange}
										/>
									) : (
										'Position: ' + this.props.playerReport.onChange.position.toUpperCase()
									)}
								</div>
								<div className="meta-detail">
									<div className="item">
										{!this.props.playerReport.readOnly ? (
											<Select
												prompt="Cards"
												currentVal={
													typeof this.state.cards[this.props.cardValue] === 'undefined'
														? ''
														: this.state.cards[this.props.cardValue].id
												}
												options={this.state.cards}
												optionsById={this.state.cardsById}
												onChange={this.onCardsChange}
											/>
										) : (
											this.props.cards
										)}
									</div>
									<div className="item">
										{!this.props.playerReport.readOnly ? (
											<Select
												prompt="Goals"
												currentVal={this.props.goalValue}
												options={this.state.goals}
												optionsById={this.state.goalsById}
												onChange={this.onGoalsChange}
											/>
										) : (
											this.props.goals
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="item grey5">
					<div className="flexContainerRow arseblogRating">
						<div className="item small ratingTitle">
							<span>arseblog</span>
						</div>
						<div className="item large">
							<div className="arseblog">
								<span className="ratingScore">{this.props.playerReport.matchRating}</span>
							</div>
						</div>
					</div>
					<div className="flexContainerRow userRating">
						<div className="item small ratingTitle">
							<span>
								{!this.props.userRating ? 'Readers' : 'Readers (' + this.props.userRating + ')'}
							</span>
						</div>
						<div className="item large">
							<div className="arseblog">
								<span className="ratingScore">{this.props.playerReport.userRating}</span>
							</div>
						</div>
					</div>
					<div className="flexContainerRow review">
						<div className="item">
							{!this.props.playerReport.readOnly ? (
								<textarea
									rows="4"
									cols="50"
									readOnly={this.props.playerReport.readOnly}
									value={this.props.playerReport.onChange.review}
									onChange={this.onTextChange}
								/>
							) : (
								<div>{this.props.playerReport.review}</div>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export { MatchSquadPlayer };



// WEBPACK FOOTER //
// ./src/components/cards/matchSquadPlayer1/MatchSquadPlayer.js